<template>
	<v-container class="dashboard-container">
		<v-row class="contentRow" justify="center">
			<v-col cols="8">
				<div class="steps-wrapper">
					<!-- Step 1 -->
					<div class="step-container clickable-step">
						<div class="step-circle">
							<v-icon size="35" color="error">fas fa-triangle-exclamation</v-icon>
						</div>
						<div class="step-text">
							<h4><b>Incident</b></h4>
						</div>
					</div>

					<!-- Arrow 1 -->
					<v-col class="arrow-col">
						<v-icon size="25">fas fa-arrow-right-long</v-icon>
					</v-col>

					<!-- Step 2 -->
					<div class="step-container clickable-step">
						<div class="step-circle">
							<v-icon size="35" color="success">fas fa-clipboard-check</v-icon>
						</div>
						<div class="step-text">
							<h4><b>Review</b></h4>
						</div>
					</div>

					<!-- Arrow 2 -->
					<v-col class="arrow-col">
						<v-icon size="25">fas fa-arrow-right-long</v-icon>
					</v-col>

					<!-- Step 3 -->
					<div class="step-container clickable-step">
						<div class="step-circle">
							<v-icon size="35" color="primary">fas fa-chalkboard-user</v-icon>
						</div>
						<div class="step-text">
							<h4><b>Training</b></h4>
						</div>
					</div>
				</div>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12">
				<!-- Account exists in tbl_incident_manager -->
				<div v-if="incident" class="saved-process-card ma-3" style="padding: 35px;">
					<v-card class="pa-5">
						<v-card-title class="text-h5">Your Incident Report account</v-card-title>
						<v-card-text>
							<p>Share these login details(Email, Password) with your company employees:</p>
							<p><b>Username:</b> {{ incident.Username }}</p>
							<p><b>Email:</b> {{ incident.Email }}</p>
							<p>
								<b>Password: </b>
								<span class="password-text">{{ showPassword ? (incident.Password || "-") : "••••••••" }}</span>
								<v-btn icon small class="ml-2" @click="showPassword = !showPassword">
									<v-icon small>{{ showPassword ? "fas fa-eye-slash" : "fas fa-eye" }}</v-icon>
								</v-btn>
							</p>
							<p><b>Created on:</b> {{ createdDate }}</p>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary" :to="'/incidentreport'">
								<v-icon left>fas fa-right-to-bracket</v-icon>
								Go to Incident Report
							</v-btn>
						</v-card-actions>
					</v-card>
				</div>

				<!-- No account yet -->
				<div v-else-if="loaded" class="saved-process-card ma-3" style="padding: 35px;">
					<h3 class="mb-2">Get started with Incident Reporting</h3>
					<p>
						You don't have an Incident Report account yet. Create one to report
						incidents, near misses, and concerns quickly, so they can be reviewed,
						acted on, and used to improve safety and training across your organisation.
					</p>
					<ul class="account-info-list">
						<li>Your account will be created automatically.</li>
						<li>Once it is created, the login details (email and password) will be shown on screen.</li>
						<li>Please share these with your company employees so they can log in and submit reports.</li>
					</ul>
					<v-btn color="primary" @click="confirmcreation = true">
						<v-icon left>fas fa-plus</v-icon>
						Create Incident Report Account
					</v-btn>
				</div>
			</v-col>
		</v-row>

		<v-dialog v-model="confirmcreation" max-width="650" persistent>
			<v-card class="pa-5">
				<v-card-title class="text-h5">
					Do you want to create an Incident Report account?
				</v-card-title>
				<v-card-text>
					The account will be created automatically and the login details will be
					shown after creation.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="confirmcreation = false">Cancel</v-btn>
					<v-btn color="primary" @click="createIncidentAccount()">
						Yes, Create
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import LoadingState from "../consts/LoadingState"
import { riskAPI } from "../api/csr/risk"

export default {
	data() {
		return {
			incident: null,
			loaded: false,
			confirmcreation: false,
			showPassword: false,
		}
	},
	computed: {
		createdDate() {
			if (!this.incident || !this.incident.Timestamp) return "-"
			const d = new Date(this.incident.Timestamp)
			return isNaN(d) ? "-" : d.toLocaleDateString()
		},
	},
	created() {
		this.viewIncidentManager()
	},
	methods: {
		createIncidentAccount() {
			this.confirmcreation = false
			riskAPI.saveIncidentManager()
				.then(() => {
					// reload from the table so the saved details (with password) are shown
					this.viewIncidentManager()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully saved!`,
						{ root: true }
					)
				})
				.catch(error => {
					this.$store.dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, { root: true })
				})
		},
		viewIncidentManager() {
			riskAPI.getIncidentManager()
				.then(data => {
					this.incident = (data && data[0]) || null
					this.loaded = true
					this.$store.dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, { root: true })
				})
				.catch(error => {
					this.loaded = true
					this.$store.dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, { root: true })
				})
		},
	},
}
</script>

<style scoped>
.steps-wrapper {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	gap: 24px;
	position: relative;
	z-index: 2;
	padding: 32px 40px;
	border: 2px solid #1e7c83;
	border-radius: 5px;
}

.step-container {
	text-align: center;
	max-width: 100px;
}

.step-circle {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto 20px auto;
	backdrop-filter: blur(10px);
	transition: all 0.3s ease;
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.step-circle:hover {
	transform: translateY(-2px);
}

.arrow-col {
	flex: 0 0 auto;
	width: auto;
	max-width: none;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0;
	padding: 0 8px;
}

.saved-process-card {
	position: relative;
	border: 2px solid #2d9b9b;
	border-radius: 12px;
	padding: 16px;
	background: #fff;
}

.incident-title {
	margin: 0;
}

.account-info-list {
	margin: 8px 0 16px 20px;
	padding: 0;
}

.account-info-list li {
	margin-bottom: 4px;
}

@media (max-width: 768px) {
	.steps-wrapper {
		flex-direction: column;
		align-items: center;
		gap: 10px;
		padding: 24px;
	}

	.arrow-col {
		height: auto;
		padding: 10px 0;
	}

	.arrow-col .v-icon {
		transform: rotate(90deg);
	}

	.step-container {
		max-width: 200px;
	}
}

@media (max-width: 1024px) and (min-width: 769px) {
	.steps-wrapper {
		padding: 24px;
		gap: 12px;
	}

	.step-circle .v-icon {
		font-size: 30px !important;
	}
}

@media (min-width: 1025px) {
	.steps-wrapper {
		padding: 32px 48px;
	}
}
</style>